const OrderSummarySkeleton = () => {
  return (
    <div className="p-7 space-y-6">
      {/* Orders Table Skeleton */}
      <div className="border-y">
        <div className="h-12 bg-customTableBg mb-4" /> {/* Header skeleton */}
        {[1, 2].map((index) => (
          <div key={index} className="flex items-center space-x-4 p-4 border-b">
            <div className="w-10 h-10 bg-gray-200 rounded animate-pulse" />
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse" />
              <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse" />
            </div>
            <div className="w-20 h-4 bg-gray-200 rounded animate-pulse" />
            <div className="w-20 h-4 bg-gray-200 rounded animate-pulse" />
          </div>
        ))}
      </div>

      {/* Summary Table Skeleton */}
      <div className="w-full lg:max-w-xs ml-auto space-y-4">
        <div className="h-10 bg-gray-200 rounded animate-pulse" />
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className="flex justify-between items-center">
            <div className="h-4 bg-gray-200 rounded w-1/3 animate-pulse" />
            <div className="h-4 bg-gray-200 rounded w-1/4 animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderSummarySkeleton;
